import type { ParameterSets } from '@ingenico/react-form-builder';

// Multi-merchant case: at least one parameter set snapshot id is returned with different logicalDeviceIds.
export function hasMultiMerchantParameterSets(
  parameterSets: readonly ParameterSets[] = [],
  logicalDeviceId?: string,
): boolean {
  const selectedParameterSet = logicalDeviceId
    ? parameterSets?.find((parameterSet) => parameterSet.logicalDeviceId === logicalDeviceId)
    : undefined;

  if (!selectedParameterSet) {
    return false;
  }

  const logicalDeviceIdsBySnapshotId = parameterSets.reduce<ReadonlyMap<string, ReadonlySet<string>>>(
    (acc, { parameterSetSnapshotId, logicalDeviceId }) =>
      parameterSetSnapshotId && logicalDeviceId
        ? new Map([
            ...acc,
            [parameterSetSnapshotId, new Set([...(acc.get(parameterSetSnapshotId) ?? []), logicalDeviceId])],
          ])
        : acc,
    new Map(),
  );
  const values = [...logicalDeviceIdsBySnapshotId.values()];
  return values.some((logicalDeviceIds) => logicalDeviceIds.size > 1);
}
